import React, { useState, useEffect } from 'react';
import './Subflow Template List.css';
import ListTable from '../../Common Components/List_Table';
import { DragDropContext } from "react-beautiful-dnd";
import DraggableTable from '../../Common Components/Draggable_Rows_Table';
import SubflowTemplateServiceController from '../../../Controllers/SubflowTemplateService';
import ConfirmPopup from '../../Common Components/Confirm_Popup';
import "react-toastify/dist/ReactToastify.css";
import CustomToaster, { notify } from '../../Common Components/Custom_Toaster';
import Preview from '../../Common Components/Slide_Preview';
import Custom_InfoBar from '../../Common Components/Custom_InfoBar';
import CalloutNamePopup from '../../Common Components/Event_Callotname_Popup';

const SubflowTemplateList = ({ onHandleClick, displayTemplateData, displayCloneTemplateData, toolTipData }) => {
  const subflowTempcont = new SubflowTemplateServiceController();
  var Spinner = require('react-spinkit');
  const tableHeading = ["", "S.No", "Callout Name", "Level", "Created/Modified Date", "Created/Modified by", "Subflow Name", "Workflow Name", "Version", "Publish", ""];
  const [subflowTableRows, setSubflowTableRows] = useState([]);
  const [subflowId, setSubflowId] = useState(1);
  const [shouldReload, setShouldReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [confirmPopupData, setConfirmPopupData] = useState({
    dataId: null,
    template: '',
    popupType: '',
    name: ''
  });
  const getJsonData = async () => {
    const body = await subflowTempcont.getSubflowTemplateList();
    setSubflowTableRows(
      Array.isArray(body) && body.length > 0
        ? body.map((item, index) => ({
          sNo: (index + 1).toString().padStart(2, '0'),
          calloutName: item.calloutName,
          level: item.levelName,
          date: item.date ? new Date(item.date).toLocaleDateString("en-IN")  : "",
          create: item.createOrModifiedBy,
          subflowName: item.templateName_SubFlow,
          workflowName: item.templateName_WorkFlow,
          version: "V" + item.versionId,
          publish: item.isPublished ? "Unpublish" : "Publish",
          preview: "",
          menu: "",
          uniqueId: item.id,
          templateData: item.TemplateData,
          item: item,
        }))
        : []
    );
  };
  const [name, setName] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setIsProcessing(true);
      await getJsonData();
      setIsProcessing(false);
      setShouldReload(false);
    }
    fetchData();
  }, [shouldReload]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result.map((item, index) => ({
      ...item,
      sNo: (index + 1).toString().padStart(2, "0"),
    }));
  };
  const handleOnDragEnd = (result) => {
    const { source, destination } = result;
    // Dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === 'listTable') {
        const reorderedList = reorder(subflowTableRows, source.index, destination.index);
        setSubflowTableRows(reorderedList);
      }
      return;
    }
  };

  const transformItemForDestination = (item) => {
    return {
      ...item,
      subflowName: 'CV Sourced',
      level: "",
      workflowName: "",
      date: "09/18/2024",
      create: "Marcel Leo",
      publish: "Publish",
      preview: "",
      menu: ''
    };
  };

  const handleDeleteTemplate = async (uniqueId) => {
    try {
      setIsLoading(true);

      const message = await subflowTempcont.removeDataOnSubflowTemplateList(uniqueId);

      notify(message, true);
      closePopupOnFinishingApiCall();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        "There was an error while performing the deletion operation. Please try again later.";

      notify(errorMessage, false);
    } finally {
      setIsLoading(false);
    }
  };




  const handlePublishTemplate = (uniqueId, mode) => {
    setIsLoading(true);
    setTimeout(async () => {
      const body = await subflowTempcont.publishSubflowTemplate(uniqueId, mode);
      setIsLoading(false);
      closePopupOnFinishingApiCall();
      const isSuccess = body?.success || body?.Success === true;
      const message = body?.response || body?.Response || body?.Message || "";
      if (!isSuccess) {
        // Business rule failure (200 OK but success = false)
        notify(message.replace("Message:", "").trim(), false);
        return;
      }
      notify(message.replace("Message:", "").trim(), true);
    }, 1000)
  }


  const closePopupOnFinishingApiCall = () => {
    setIsPopupOpen(false);
    setShouldReload(true);
  }

  const openPopup = (type, id, template, name) => {
    setIsPopupOpen(!isPopupOpen);
    setConfirmPopupData(
      {
        dataId: id,
        template: template,
        popupType: type,
        name: name
      }
    )
    setName(name);
  }
  const editClick = (templateData, id, requestBody, subflowName) => {
     if (requestBody.isPublished) {
      notify(
              `${subflowName} is published. Edit action is disabled.`,
              false
      );
      return;
     }
    displayTemplateData(requestBody.templateData, id, requestBody, subflowName);
  }

  const cloneClick = (templateData, id, requestBody, subflowName) => {
    if (requestBody.isPublished)
      notify("The published subflow template cannot be cloned.", false);
    else
      displayCloneTemplateData(requestBody.templateData, id, requestBody, subflowName);
  }

  const [openPreview, setOpenPreview] = useState(false);
  const [imgSource, setImgSource] = useState('');
  const openImgPreview = (id, source) => {
    setSubflowId(id);
    setImgSource(source);
    setOpenPreview(!openPreview);
  }

  const [subflowSearchText, setSubflowSearchText] = useState('');
  const search = (subflowSearchText || "").toLowerCase();

  const filteredSubflowTemp = (subflowTableRows || []).filter((subflow) =>
    Object.values(subflow).some((value) =>
      String(value).toLowerCase().includes(search)
    )
  );
  console.log("subflowSearchText", subflowSearchText);
console.log("filteredSubflowTemp", filteredSubflowTemp);
  const handleSubflowSearch = (event) => {
    setSubflowSearchText(event.target.value)
  }
  
  const handleSubflowSearchClear = () => {
    setSubflowSearchText('');
  }

  const [isInfoBarVisible, setIsInfoBarVisible] = useState(true);
  const handleHideInfoBar = () => {
    setIsInfoBarVisible(!isInfoBarVisible);
  }

  return (
    <>
      <ListTable handleListClick={onHandleClick} template={true} task={false} searchText={subflowSearchText} handleSearch={handleSubflowSearch} handleSearchClear={handleSubflowSearchClear} />
      {
        isProcessing ?
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%' }}>
              <Spinner name="ball-spin-fade-loader" color="#02acf6" />
            </div>
          </> :
          <>
            {/* <Custom_InfoBar toolTipData={toolTipData} /> */}

            <DragDropContext onDragEnd={handleOnDragEnd}>
              <DraggableTable
                handleListClick={onHandleClick}
                openPopup={openPopup}
                cloneClick={cloneClick}
                editClick={editClick}
                drag={true}
                row={filteredSubflowTemp}
                heading={tableHeading}
                template={true}
                workflow={false}
                event={false}
                task={false}
                droppableId="subflowlistTable"
                openImgPreview={openImgPreview}
                searchText={subflowSearchText}
              />
            </DragDropContext>
          </>
      }
      <ConfirmPopup
        openConfirmationPopup={isPopupOpen}
        onClose={openPopup}
        handleDeleteTemplate={handleDeleteTemplate}
        handlePublishTemplate={handlePublishTemplate}
        isLoading={isLoading}
        popupData={confirmPopupData}
      />
      <Preview openPre={openPreview} closePre={openImgPreview} id={subflowId} source={imgSource} />
      <CustomToaster />
    </>
  );
}

export default SubflowTemplateList;